import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import NoteEditor from 'components/NoteEditor';
import { NoteCard } from 'components/UserContentCards';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: ({ isCollaborationContent }) =>
      theme.spacing(0, 0, 0, isCollaborationContent ? 1.875 : 1.5),
  },
}));

const RailNoteCard = (
  {
    className,
    focusOptionsMenu = () => {},
    isCollaborationContent = false,
    onNoteEditorClose = () => {},
    userContentItem,
    ...props
  },
  ref,
) => {
  const classes = useStyles({ isCollaborationContent });
  const [isEditing, setIsEditing] = useState(false);

  // Add or remove card Elevation based on focus state
  const [elevation, setElevation] = useState(null);
  const [variant, setVariant] = useState('outlined');
  const onBlur = useCallback(() => {
    setElevation(null);
    setVariant('outlined');
  }, []);
  const onFocus = useCallback(() => {
    setElevation(8);
    setVariant('elevation');
  }, []);

  const { userFirstName, userLastName } = userContentItem;
  const fullName =
    userFirstName || userLastName
      ? `${userFirstName ?? ''} ${userLastName ?? ''}`
      : '';
  const title = isCollaborationContent
    ? fullName || 'Shared Note'
    : fullName || 'My Note';

  useEffect(
    function focusMenuOnNoteEditorClose() {
      focusOptionsMenu(userContentItem);
    },
    [focusOptionsMenu, userContentItem],
  );

  return (
    <>
      {isEditing ? (
        <NoteEditor
          elevation={8}
          note={userContentItem}
          onClose={() => {
            setIsEditing(false);
            onNoteEditorClose();
          }}
          onSave={async (properties) =>
            await userContentItem.change(properties).save()
          }
          variant={'elevation'}
        />
      ) : (
        <NoteCard
          cardId={`rail-note-card-${userContentItem.id}`}
          className={clsx(classes.root, className)}
          elevation={elevation}
          onBlur={onBlur}
          onEdit={() => {
            setIsEditing(true);
            onBlur();
          }}
          onFocus={onFocus}
          isCollaborationContent={isCollaborationContent}
          isLearningToolsMenu={false}
          ref={ref}
          tabIndex={0}
          title={title}
          titleComponentForDeleteDialog="h3"
          userContentItem={userContentItem}
          variant={variant}
          {...props}
        />
      )}
    </>
  );
};

// No PropTypes for forwardRef component
export default forwardRef(RailNoteCard);
